"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FBDTextLayout = void 0;
class FBDTextLayout {
    constructor(width, characterWidth, scale) {
        this.width = width;
        this.characterWidth = characterWidth * scale;
        this.charactersPerLine = Math.floor(this.width / this.characterWidth);
    }
    format_text(text) {
        const lines = text.split("\n");
        let str = "";
        while (lines.length > 0) {
            let curr_width = 0;
            const tokenized_text = lines.shift().split(" ");
            while (tokenized_text.length > 0) {
                const next = tokenized_text.shift();
                if (next.length == 0) { }
                else if (next == "\n") {
                    curr_width = 0;
                    str += "\n";
                }
                else if (next.length > (this.charactersPerLine - curr_width)) {
                    curr_width = 0;
                    str += "\n";
                    if (next.length > this.charactersPerLine) {
                        str += next.substring(0, this.charactersPerLine);
                        str += "\n";
                        tokenized_text.unshift(next.substring(this.charactersPerLine));
                    }
                    else {
                        tokenized_text.unshift(next);
                    }
                }
                else {
                    curr_width += next.length + 1;
                    str += next + " ";
                }
            }
            str += "\n";
        }
        return str;
    }
}
exports.FBDTextLayout = FBDTextLayout;
